/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="LinkedIn 24">
      <path
        fill="#0E0E0E"
        d="M17.028 8.316c4.197 0 4.972 2.762 4.972 6.352v7.315h-4.142v-6.485c0-1.547-.029-3.537-2.154-3.537-2.157 0-2.488 1.686-2.488 3.425v6.597H9.075V8.647h3.975v1.822h.056c.553-1.048 1.906-2.153 3.922-2.153ZM6.476 21.953H2.331V8.617h4.145v13.336ZM4.404 2.018A2.404 2.404 0 0 1 6.806 4.42 2.405 2.405 0 0 1 2 4.42a2.404 2.404 0 0 1 2.404-2.402Z"
        className="SVG"
      />
    </g>
  </svg>
);

export const LinkedInIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'linked-in-icon'}
      icon={LinkedIn}
      {...props}
      size={size}
    />
  );
};
